module.exports = __webpack_public_path__ + "img/dd-logo-mitsubishi.062ea544.png";